import React from 'react';

/**
 * A plain <select>, styled to sit beside the sign-up controls.
 *
 * On a phone the browser draws its own picker (the wheel on iOS, the sheet on
 * Android) — no inner-scrolling dropdown, which is the part that misbehaves on
 * some Android browsers. Works inside an antd Form.Item (value / onChange) and
 * on its own. `options` is [{ value, label }].
 */
export default function NativeSelect({
  value, onChange, options, placeholder, dark = false, id, className = '', style = {}, disabled = false,
  ariaLabel,
}) {
  const colors = dark
    ? { background: '#1a1a1a', color: '#fff', border: '1px solid #444' }
    : { background: '#fff', color: '#262626', border: '1px solid #d9d9d9' };
  return (
    <select
      id={id}
      aria-label={ariaLabel}
      className={`native-select${className ? ` ${className}` : ''}`}
      value={value == null ? '' : value}
      disabled={disabled}
      onChange={(e) => { if (onChange) onChange(e.target.value || undefined); }}
      style={{
        width: '100%',
        height: 52,
        fontSize: 16,
        borderRadius: 8,
        padding: '0 36px 0 12px',
        appearance: 'none',
        WebkitAppearance: 'none',
        backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path d='M1 1l5 5 5-5' fill='none' stroke='${dark ? '%23bbb' : '%23888'}' stroke-width='2'/></svg>")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 12px center',
        ...colors,
        ...style,
      }}
    >
      {placeholder ? <option value="" disabled>{placeholder}</option> : null}
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}
